import React, {useState} from "react";
import closeIcon from "../../../img/closeIcon.svg";
import {Validation} from "../../../utils/Validation/Validation";

const SubmitBugFixModal = (props) => {

    const {
        onCloseModal,
        onHandleReturnDocForCorrection,
        isModalMessage
    } = props;

    const isDescriptionProblem = Validation();

    return (
        <div className="submit-bug-fix-modal__container">
            <div className="submit-bug-fix-modal">
                <div className="submit-bug-fix-modal__title">
                    <h3>Submit to bug fixes</h3>
                    <img onClick={onCloseModal} src={closeIcon} alt={'иконка крестик'}/>
                </div>
                <div className="submit-bug-fix-modal-input-block">
                    <label className="submit-bug-fix-modal-input-block__label">Describe the reason for refusing to sign</label>
                    <textarea className="submit-bug-fix-modal-input-block__input"
                        value={isDescriptionProblem.value}
                        onChange={isDescriptionProblem.onChange}
                    />
                    <p className="modal-input-block-error-text">{isModalMessage}</p>
                </div>
                <div className="submit-bug-fix-modal__buttons-block">
                    <button onClick={() => onCloseModal()} className="submit-bug-fix-modal__button-cancel" type={"button"}>Cancel</button>
                    <button onClick={() => onHandleReturnDocForCorrection(isDescriptionProblem.value)} className="submit-bug-fix-modal__button-create" type={"button"}>Send</button>
                </div>
            </div>
        </div>
    )
}
export default SubmitBugFixModal;